import { LessonProblem, StudentProblemResult, ProblemResults } from '@yandex-int/k-common/typings';
import { Text } from 'platform-components';
import React from 'react';

import { isOpenAnswer, isTheory } from 'store/problems/utils';

import { StatItem } from '../lesson-content__stat-item-wrapper';

export const SuccessfulStudents = (props: {
    problemLink: LessonProblem;
    studentProblemResult: StudentProblemResult | null;
    lessonProblemResult: ProblemResults;
}) => {
    const { problemLink, studentProblemResult, lessonProblemResult } = props;
    const value = isTheory(problemLink?.problem) ? lessonProblemResult?.seen : lessonProblemResult?.progress?.success;
    const descriptionId = isOpenAnswer(problemLink?.problem)
        ? 'studentLessonStat.completedInClass'
        : 'studentLessonStat.classSuccessfulStudents';

    return (
        <StatItem>
            <Text id={descriptionId} values={{ mode: studentProblemResult?.type }} />
            <span className="lesson-content__stat-detail-value">
                <Text weight={Text.WEIGHT.L}>{value || <>&mdash;</>}</Text>
            </span>
        </StatItem>
    );
};
